export const CANVAS_GUIDE_STORAGE_KEY = 'morpherd_canvas_guide_v1'

export function hasSeenCanvasGuide() {
  try {
    return window.localStorage.getItem(CANVAS_GUIDE_STORAGE_KEY) === 'seen'
  } catch {
    return false
  }
}

export function markCanvasGuideSeen() {
  try {
    window.localStorage.setItem(CANVAS_GUIDE_STORAGE_KEY, 'seen')
  } catch {
    // The guide still works when storage is unavailable.
  }
}
